import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-focused",
  templateUrl: "./focused.component.html",
  styleUrls: ["./focused.component.scss"]
})
export class FocusedLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
